import { useEffect } from "react";
import { watchConsent } from "../lib/analytics";

export default function CookieBanner() {
  useEffect(() => watchConsent(), []);
  return null;
}
